import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';

import TechnicalTypesManagerPage from 'src/pages/Dashboard/System/TechnicalTypes/TechnicalTypesManagerPage';
import systemOptionsStore from 'src/stores/systemOptionsStore';

const Competitions = () => {
  const {
    competitions: items,
    deleteCompetition: deleteItem,
    deleteAllCompetitions: deleteAllItems,
    fetchCompetitions: fetchItems,
    isLoading,
    saveCompetition: saveItem,
  } = systemOptionsStore(systemOptionsState => systemOptionsState);

  return (
    <TechnicalTypesManagerPage
      entityType="competitions"
      storeSelectors={{ items, isLoading, fetchItems, saveItem, deleteItem, deleteAllItems }}
      i18nKeys={{
        prefix: 'system.competitions',
        emptyPrefix: 'empty.competitions',
        errorsPrefix: 'system.competitions.errors',
      }}
      emptyIcon={<EmojiEventsOutlinedIcon />}
      editorModalId="competition-editor"
      withIcon
    />
  );
};

export default Competitions;
